import { render } from "./NewMemberBox.vue?vue&type=template&id=d5e7dcd6&scoped=true"
import script from "./NewMemberBox.vue?vue&type=script&lang=js"
export * from "./NewMemberBox.vue?vue&type=script&lang=js"

import "./NewMemberBox.vue?vue&type=style&index=0&id=d5e7dcd6&scoped=true&lang=css"

import exportComponent from "/Users/georgeconstantine/Documents/import/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d5e7dcd6"]])

export default __exports__